var _excluded = ["children"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef } from 'react';
import { wrapReactionHook } from "../../hooks";
import { Button, Table } from 'antd';
import { useField } from '@formily/react';
import { useCssInJs } from "../../hooks";
import { genAdSpacesStyle } from "./styles";
import cx from 'classnames';
export var AdSpaces = wrapReactionHook(function (props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var prefix = 'ad-spaces';
  var field = useField();
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genAdSpacesStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var columns = useRef([{
    title: '广告位置',
    dataIndex: 'place',
    key: 'place'
  }, {
    title: '图片、视频',
    dataIndex: 'images',
    key: 'images'
  }, {
    title: '备注说明',
    dataIndex: 'comment',
    key: 'comment'
  }]).current;
  var readOnly = field.readOnly;
  return wrapSSR( /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, prefix)
  }, /*#__PURE__*/React.createElement(Table, {
    columns: columns
  }), readOnly ? null : /*#__PURE__*/React.createElement(Button, {
    block: true,
    type: "dashed",
    className: cx(hashId, 'append')
  }, "\u6DFB\u52A0\u5E7F\u544A\u4F4D")));
});